import window from '../globalWrappers/window.js';
import getAppRoot from '../utilities/getAppRoot.js';

function createLoginLink(successMessage) {
  let loginUrl = `/${getAppRoot()}/account/login` + window.location.search;

  if (successMessage) {
    loginUrl += `${window.location.search ? '&' : '?'}successMsg=${encodeURIComponent(successMessage)}`;
  }

  return loginUrl;
}

export default createLoginLink;